<template>
  <div>
    <NuxtPage/>
  </div>
</template>
<style lang="less">
.generate-font-sizes(@i) when (@i <= 82) {
  .ql-size-@{i}px {
    font-size: unit(@i, px);
  }
  .generate-font-sizes(@i + 1);
}
.generate-font-sizes(8);

</style>
